import styled from 'styled-components';
import {
  colors,
  boxShadow,
  breakpointsNumber,
  headerHeightMobile,
  sideMenuWidth,
  text
} from '../../styles';

export const StyledMobileNav = styled.nav`
  position: fixed;
  top: ${headerHeightMobile}rem;
  width: 100vw;
  z-index: 10;
  background: ${colors.white};
  box-shadow: ${boxShadow.medium};
  max-height: calc(
    ${window.innerHeight / text.base}rem - ${headerHeightMobile}rem
  );
  overflow-y: auto;
`;

export const StyledFullscreenNav = styled.nav`
  position: absolute;
  z-index: 2;
  background: ${colors.white};
  width: ${sideMenuWidth}px;
  min-height: 100%;

  &:empty {
    display: none;
  }

  &:before {
    content: '';
    display: block;
    height: 6.5rem;
    background: linear-gradient(126.05deg, #016b36 0%, #02a452 100%);
    .is-scrolled & {
      height: 4.5rem;
    }
  }
  @media screen and (min-width: ${breakpointsNumber.largeMonitor}px) {
    box-shadow: ${boxShadow.medium};
  }
  @media screen and (max-width: ${breakpointsNumber.largeMonitor - 1}px) {
    z-index: ${({ tabletMenuVisible }) => (tabletMenuVisible ? 2 : -1)};
    opacity: ${({ tabletMenuVisible }) => (tabletMenuVisible ? 1 : 0)};
    transition: opacity 0.3s ease;
  }

  @media only screen and (max-width: ${breakpointsNumber.tablet - 1}px) {
    display: none !important;
  }
`;
